import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PhxButtonGroupModule } from "./../button-group/phx-button-group.module";
import { PhxButtonModule } from "./..//button/phx-button.module";
import { PhxIconModule } from "./../icon/icon.module";
import { PhxPaginationComponent } from "./phx-pagination.component";
import { PhxSkeletonModule } from "./../skeleton/phx-skeleton.module";
import { PhxNavigationButtonModule } from "../navigation-button/phx-navigation-button.module";

@NgModule({
    imports: [CommonModule, PhxNavigationButtonModule],
    declarations: [PhxPaginationComponent],
    exports: [PhxPaginationComponent],
})
export class PhxPaginationModule {}